import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BBACoursePage: React.FC = () => {
  const courseData = {
    title: "BBA (Bachelor of Business Administration)",
    shortName: "BBA",
    duration: "3 years",
    description: "Bachelor's degree program focused on business administration, management principles, and entrepreneurship",
    overview: "Bachelor of Business Administration (BBA) is a 3-year undergraduate program that provides comprehensive study of business management, organizational behavior, marketing, finance, and entrepreneurship. This course covers management principles, business strategy, human resources, operations management, and leadership skills, preparing students for careers in management, consulting, and business development.",
    eligibility: [
      "10+2 in any stream",
      "Minimum 50% marks in 12th standard",
      "Some colleges require entrance exams",
      "Interest in business and management"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Principles of Management",
          "Business Economics",
          "Financial Accounting",
          "Business Communication",
          "Business Mathematics",
          "Computer Applications"
        ]
      },
      {
        year: 2,
        subjects: [
          "Marketing Management",
          "Human Resource Management",
          "Financial Management",
          "Operations Management",
          "Business Law",
          "Organizational Behavior"
        ]
      },
      {
        year: 3,
        subjects: [
          "Strategic Management",
          "Entrepreneurship",
          "International Business",
          "Business Research Methods",
          "Summer Internship",
          "Final Project"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Management Trainee",
        "Business Analyst",
        "Marketing Executive",
        "HR Executive",
        "Sales Manager",
        "Operations Manager",
        "Business Development Executive",
        "Project Coordinator",
        "Consultant",
        "Entrepreneur"
      ],
      industries: [
        "Corporate Sector",
        "Consulting Firms",
        "Banking and Finance",
        "Marketing Agencies",
        "E-commerce",
        "Healthcare Management",
        "Retail Industry",
        "Manufacturing",
        "Hospitality",
        "Startups"
      ],
      averageSalary: "₹3-8 LPA (Fresher), ₹12-40 LPA (Experienced)",
      topRecruiters: [
        "Deloitte, PwC, EY",
        "Amazon, Flipkart",
        "HDFC Bank, ICICI",
        "Wipro, TCS, Infosys",
        "ITC, HUL, P&G",
        "Consulting Companies"
      ]
    },

    admissionProcess: [
      "Merit-based admission through 12th marks",
      "Entrance exams like IPU CET, SET, etc.",
      "Some top colleges conduct their own entrance tests",
      "Group discussions and personal interviews",
      "Online application process"
    ],

    topColleges: [
      {
        name: "Shaheed Sukhdev College of Business Studies",
        location: "Delhi",
        fees: "₹25,000 per year",
        ranking: "DU College"
      },
      {
        name: "Christ University",
        location: "Bangalore",
        fees: "₹3,00,000 per year",
        ranking: "NIRF Ranking: 25"
      },
      {
        name: "Symbiosis Centre for Management and HRD",
        location: "Pune",
        fees: "₹4,50,000 per year",
        ranking: "Deemed University"
      },
      {
        name: "Amity Business School",
        location: "Noida",
        fees: "₹4,00,000 per year",
        ranking: "Private University"
      },
      {
        name: "Loyola College",
        location: "Chennai",
        fees: "₹75,000 per year",
        ranking: "NAAC A+ Grade"
      }
    ],

    skills: [
      "Leadership Skills",
      "Communication Skills",
      "Analytical Thinking",
      "Problem Solving",
      "Team Management",
      "Strategic Planning",
      "Project Management",
      "Presentation Skills",
      "Decision Making",
      "Entrepreneurial Mindset"
    ],

    futureScope: "Excellent growth prospects with increasing business complexity, startup ecosystem growth, digital transformation, and rising demand for management professionals across all industries.",

    faqs: [
      {
        question: "What's the difference between BBA and B.Com?",
        answer: "BBA focuses on management and leadership skills with broader business perspective, while B.Com emphasizes accounting, finance, and commerce fundamentals."
      },
      {
        question: "Can I pursue MBA after BBA?",
        answer: "Yes, BBA provides excellent foundation for MBA. Many top B-schools prefer candidates with business administration background."
      },
      {
        question: "Are there good placement opportunities after BBA?",
        answer: "Yes, companies across sectors recruit BBA graduates for management trainee programs, business development, and operational roles."
      },
      {
        question: "Can I start my own business after BBA?",
        answer: "Yes, BBA provides comprehensive business knowledge, entrepreneurship skills, and management expertise needed to start and run a successful business."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BBACoursePage;
